// extracted by mini-css-extract-plugin
export var accordion = "_if-0";
export var chevron = "_if-3";
export var closed = "_if-2";
export var content = "_if-4";
export var open = "_if-1";
export var rotate = "_if-5";